import { render, staticRenderFns } from "./T05.vue?vue&type=template&id=c837f2e0&scoped=true"
import script from "./T05.vue?vue&type=script&lang=js"
export * from "./T05.vue?vue&type=script&lang=js"
import style0 from "./T05.vue?vue&type=style&index=0&id=c837f2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c837f2e0",
  null
  
)

export default component.exports